//src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import apiClient from './plugins/axios'; // Import the configured Axios instance
import './assets/global.css';
import './assets/variables.scss';

loadFonts()

const app = createApp(App);

app.config.globalProperties.$axios = apiClient; // Make the configured Axios instance available globally

app.use(router)
   .use(store)
   .use(vuetify)
   .mount('#app');
